export default __webpack_public_path__ + "static/assets/03ca595a957a7e134daf6ede88176e1b.png";